import GetGifsById from "../../../../src/mdx/api/endpoints/get-gifs-by-id.mdx";
import * as React from 'react';
export default {
  GetGifsById,
  React
};